import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InsuranceSubscriptionStatusComponent} from './insurance-subscription-status/insurance-subscription-status.component';
import {ForceFocusDirective} from './force-focus-directive';


@NgModule({
  declarations: [InsuranceSubscriptionStatusComponent, ForceFocusDirective],
  imports: [
    CommonModule,
  ],
  exports: [InsuranceSubscriptionStatusComponent, ForceFocusDirective],
})
export class SharedComponentsModule {
}
